import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import GlobalFooterPattern from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import {
    Cards,
    Careers,
    Carousel,
    Hero,
    LiftedBanner,
    SocialProof,
    HeroTeam24Promotion
} from "./sections";

export const HomePageTemplate = () => {
    const isTeam24Homepage = FeatureGates.getExperimentValue(
        "wac-homepage-team24-rollout",
        "ShowNewHomepage",
        false
    );

    const isTeam24PromotionHero = FeatureGates.checkGate(
        "wac-team-24-promotion-hero-and-banner"
    );

    if (isTeam24Homepage) {
        return (
            <UFOSegment name="home-page">
                <div>
                    <div>team24 promo</div>
                    <GlobalNavigation showTryNow={true} productKey={"home"} />
                    <div>hero</div>
                    <div>Work like the world's best teams</div>
                    <div>Teams across the globe run on Atlassian</div>
                    <div>Empower everyone, on every team</div>
                    <div>customer stories</div>
                    <div>The foundation of every Atlassian's product</div>
                    <div>team24 banner</div>
                    <div>Connect your favorite tools with ours</div>
                    <div>Help us shape the future of teamwork</div>
                    <div>Unleash the power of teamwork</div>
                    <GlobalFooterPattern />
                </div>
            </UFOSegment>
        );
    }
    return (
        <UFOSegment name="home-page">
            <div>
                <GlobalNavigation showTryNow={true} productKey={"home"} />
                {isTeam24PromotionHero ? <HeroTeam24Promotion /> : <Hero />}
                <LiftedBanner />
                <Carousel />
                <SocialProof />
                <Cards />
                <Careers />
                <GlobalFooterPattern />
            </div>
        </UFOSegment>
    );
};
